document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-metafield-wrapper').forEach(wrapper => {
    const text = wrapper.querySelector('.collection-metafield-text');
    const button = wrapper.querySelector('.read-toggle');

    if (text.scrollHeight > text.clientHeight) {
      button.hidden = false;
    }

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';

      text.classList.toggle('collapsed');
      button.setAttribute('aria-expanded', !expanded);
      button.innerText = expanded ? 'Read more' : 'Read less';
    });
  });
});